"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var defaultBodyStyles = [
    {
        text: 'SUVs',
        image: "/home-assets/nba/suv.png?width=150",
        filters: { bodyStyles: ['Suv'] }
    },
    {
        text: 'Trucks',
        image: "/home-assets/nba/truck.png?width=150",
        filters: { bodyStyles: ['Pickup'] }
    },
    {
        text: 'Sedans',
        image: "/home-assets/nba/sedan.png?width=150",
        filters: { bodyStyles: ['Sedan'] }
    },
    {
        text: 'Coupes',
        image: "/home-assets/nba/coupe.png?width=150",
        filters: { bodyStyles: ['Coupe'] }
    },
    {
        text: 'Hatchbacks',
        image: "/home-assets/nba/hatchback.png?width=150",
        filters: { bodyStyles: ['Hatchback'] }
    },
    {
        text: 'Electric',
        image: "/home-assets/nba/electric.png?width=150",
        filters: { fuelTypes: ['Electric'] }
    },
    {
        text: 'Wagons',
        image: "/home-assets/nba/wagon.png?width=150",
        filters: { bodyStyles: ['Wagon'] }
    },
    {
        text: 'Convertibles',
        image: "/home-assets/nba/convertible.png?width=150",
        filters: { bodyStyles: ['Convertible'] }
    },
    {
        text: 'Minivans',
        image: "/home-assets/nba/minivan.png?width=150",
        filters: { bodyStyles: ['MiniVan'] }
    },
    {
        text: 'View all',
        image: "/merch-assets/icons/view-all.svg",
        filters: {}
    }
];
exports.default = defaultBodyStyles;
//# sourceMappingURL=bodyStylesList.js.map